import { validCurp } from '../services/validators'

// RFC validation regex pattern based on Mexican official format
// RFC: 3-4 letters + 6 digits (YYMMDD) + 3 alphanumeric characters
export const rfcRegex = /^[A-ZÑ&]{3,4}[0-9]{6}[A-Z0-9]{3}$/

const fiscalInfoValidator = values => {
  const errors = {}

  // RFC validation
  if (!values.rfc) {
    errors.rfc = 'El RFC es requerido'
  } else if (!rfcRegex.test(values.rfc.toUpperCase())) {
    errors.rfc = 'El formato del RFC no es válido'
  }

  // Nationality validation
  if (!values.nationality) {
    errors.nationality = 'El país de origen es requerido'
  }

  // CURP validation - mandatory only for Mexican nationality (MX)
  if (values.nationality === 'MX') {
    if (!values.curp) {
      errors.curp = 'La CURP es requerida para nacionalidad mexicana'
    } else if (!validCurp(values.curp.toUpperCase())) {
      errors.curp = 'El formato de la CURP no es válido'
    }
  } else if (values.curp && !validCurp(values.curp.toUpperCase())) {
    // If CURP is provided for non-Mexican nationality, validate format
    errors.curp = 'El formato de la CURP no es válido'
  }

  if (!values.notificationAddress || (typeof values.notificationAddress === 'string' && !values.notificationAddress.trim())) {
    errors.notificationAddress = 'El domicilio de notificación es requerido'
  }

  // Beneficiaries validation
  if (
    !values.beneficiaries ||
    !Array.isArray(values.beneficiaries) ||
    values.beneficiaries.length === 0
  ) {
    errors.beneficiaries = 'Debe completar al menos un beneficiario'
  } else {
    const { beneficiaries } = values
    let completedBeneficiaries = []
    let totalPercentage = 0
    const beneficiaryErrors = []

    beneficiaries.forEach((beneficiary, index) => {
      const beneficiaryError = {}

      // Check if this beneficiary has any data
      const hasName =
        beneficiary && beneficiary.nombre && beneficiary.nombre.trim()
      const hasRelationship =
        beneficiary && beneficiary.parentesco && beneficiary.parentesco.trim()
      const hasAddress =
        beneficiary && beneficiary.domicilio && beneficiary.domicilio.trim()
      const hasPercentage =
        beneficiary &&
        beneficiary.porcentaje &&
        beneficiary.porcentaje.toString().trim() &&
        !isNaN(Number(beneficiary.porcentaje)) &&
        Number(beneficiary.porcentaje) > 0

      const hasAnyData =
        hasName || hasRelationship || hasAddress || hasPercentage

      if (hasAnyData) {
        // Check if this is a complete beneficiary (all required fields)
        const isComplete =
          hasName && hasRelationship && hasAddress && hasPercentage

        // If beneficiary has any data, validate all required fields
        if (!hasName) {
          beneficiaryError.nombre = 'El nombre es requerido'
        }

        if (!hasRelationship) {
          beneficiaryError.parentesco = 'El parentesco es requerido'
        }

        if (!hasAddress) {
          beneficiaryError.domicilio = 'El domicilio es requerido'
        }

        if (!hasPercentage) {
          beneficiaryError.porcentaje = 'El porcentaje es requerido'
        } else {
          const percentage = Number(beneficiary.porcentaje)
          if (percentage < 1 || percentage > 100) {
            beneficiaryError.porcentaje =
              'El porcentaje debe estar entre 1 y 100'
          } else if (isComplete) {
            // Only count percentage if this is a complete beneficiary
            totalPercentage += percentage
            completedBeneficiaries.push(beneficiary)
          }
        }
      }

      beneficiaryErrors[index] = beneficiaryError
    })

    // Check if at least one beneficiary is completed
    if (completedBeneficiaries.length === 0) {
      errors.beneficiaries = {
        _error: 'Debe completar al menos un beneficiario',
      }
    } else if (totalPercentage !== 100) {
      // Check percentage total - must be exactly 100%
      errors.beneficiaries = {
        _error: `La suma de porcentajes debe ser exactamente 100% (actual: ${totalPercentage}%)`,
      }
    }

    // Add individual beneficiary errors if any
    const hasFieldErrors = beneficiaryErrors.some(
      error => Object.keys(error).length > 0,
    )
    if (hasFieldErrors) {
      if (!errors.beneficiaries) {
        errors.beneficiaries = {}
      }
      beneficiaryErrors.forEach((error, index) => {
        if (Object.keys(error).length > 0) {
          errors.beneficiaries[index] = error
        }
      })
    }
  }

  return errors
}

export default fiscalInfoValidator
